import { render, staticRenderFns } from "./newsPageAchieve.vue?vue&type=template&id=4160a0bf&"
import script from "./newsPageAchieve.vue?vue&type=script&lang=js&"
export * from "./newsPageAchieve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports